import { Component } from "@angular/core";
import { SignupService } from "../../../services/signup.service";
import { RegisterVM } from "../../../models";
import { Router } from "@angular/router";

@Component({
    selector: 'step2-fail',
    templateUrl: './step2fail.component.html'
})
export class Step2FailComponent {

  constructor(private signupService: SignupService, private router: Router) {
        
  }

  continue() {
    this.signupService.overrideClientAssessment = true;

    this.router.navigateByUrl('/signup-3');
  }
}
